import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { Toasts } from "../../toasts";
import { ActualizarUsuario } from "./modalUsuarioRenta";
import { CambiarClave } from "../../comun/modalCambiarClave";
//UI
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton, WarningButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "idinmueble",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numficha",
    label: "USUARIO",
    width: "70px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "nombrepropie",
    label: "NOMBRES",
    width: "250px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "dirinmueble",
    label: "OPCIONES",
    width: "250px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaUsuarioRenta(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [persona, setPersona] = useState();
  const [usuarioH, setUsuarioH] = useState();
  const [idUsuario] = useState();
  const [mostrar2, setMostrar2] = useState(false);
  const [operacion, setOperacion] = useState();
  const permiso = JSON.parse(localStorage.getItem("accusuariorenta"));
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [deshabilitado] = useState(false);
  const [configCome] = useState();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const renderizar = () => {
    setMostrar5(false);
    setPersona();
    setUsuarioH();
    seleccionarUsuarios();
  };

  useEffect(() => {
    seleccionarUsuarios();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const seleccionarUsuarios = () => {
    setActivate(true);
    let endpoint = op.conexion + `/api/aseo/modulouser`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
  };

  const gestionarUsuario = (index, op, per) => (event) => {
    event.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        setActivate(true);
        setPersona({
          cedula: index.cedula,
          nombres: index.nombres,
          apellidos: index.apellidos,
          correoe: index.correoe,
          tlf1: index.tlf1,
          tlf2: index.tlf2,
          fnacimiento: index.fnacimiento,
          nacionalidad: index.nacionalidad,
          sexo: index.sexo,
          direccion: index.direccion,
        });
        setUsuarioH(index);
        setMostrar5(true);
        setActivate(false);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
            ? "No posee permiso para Editar"
            : op === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const cerrarModalActualizar = () => {
    setUsuarioH();
    setPersona();
    setMostrar5(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
    }
    setUsuarioH();
    setPersona();
    setMostrar5(false);
    window.location.href = "/usuariosHacienda";
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };
  const exitHandler = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion de Usuarios</h3>
        <a onClick={exitHandler} className="text-light fw-bold fs-6">
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between ">
        <div className="col-4 m-0 p-0">
          <SearchInput className='search-input ' placeholder="Buscar" onChange={handleSearch} />
        </div>
        <div className="col-auto m-0 p-0 d-flex gap-2">
          <WarningButton
            icon="fa-key"
            disabled={
              permiso &&
              permiso.substring(1, 2) !== "1" &&
              permiso.substring(2, 3) !== "1"
            }
            onClick={cambiarClave}
          >
            Cambiar Clave
          </WarningButton>

          <PrimaryButton
            icon="fa-plus m-0"
            onClick={gestionarUsuario(
              "",
              1,
              permiso.toString().substring(1, 2)
            )}
            disabled={permiso && permiso.substring(1, 2) !== "1"}
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idusuario} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //  width: "10px",
                    }}
                  >
                    {item.idusuario}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "70px",
                    }}
                  >
                    {item.login}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "250px",
                    }}
                  >
                    {item.nombres}
                  </td>

                  <td
                    align="center"
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "180px",
                      padding: 0,
                    }}
                  >
                    <button
                      onClick={gestionarUsuario(
                        item,
                        4,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        2,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        3,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <CambiarClave show={mostrar2} onHide={handleCloseClave} />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ActualizarUsuario
        show={mostrar5} /* titulo={titulo1} */ /* mensaje={msg1} */
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        render={renderizar}
      />
    </div>
  );
}

export default TablaUsuarioRenta;
